import { AddAccommodationRoom } from "Bands/pages/event-accommodation-block/containers/AddAccommodationRoom";
import { IAccommodationBlock, IAccommodationRoomType } from "Bands/types";
import { useState } from "react";
import { copy } from "shared/assets";
import { Title } from "shared/components";
import { Spacer } from "shared/layout";
import { AccommodationRoomTable } from "../AccommodationRoomTable/AccommodationRoomTable";
import { DeleteAccommodationRoomModal } from "../DeleteAccommodationRoomModal/DeleteAccommodationRoomModal";
import { EditAccommodationRoomModal } from "../EditAccommodationRoomModal/EditAccommodationRoomModal";

interface EditAccommodationRoomsProps {
  block: IAccommodationBlock;
}

const { accommodationBlock: blockCopy } = copy;

export const EditAccommodationRooms: React.FC<EditAccommodationRoomsProps> = ({
  block,
}) => {
  const [showEditModal, setShowEditModal] =
    useState<IAccommodationRoomType | null>();
  const [showDeleteModal, setShowDeleteModal] =
    useState<IAccommodationRoomType | null>();

  return (
    <Spacer size="m">
      {showDeleteModal && (
        <DeleteAccommodationRoomModal
          accommodationRoom={showDeleteModal}
          blockId={block.id}
          handleClose={() => setShowDeleteModal(null)}
        />
      )}
      {showEditModal && (
        <EditAccommodationRoomModal
          accommodationRoom={showEditModal}
          blockId={block.id}
          handleClose={() => setShowEditModal(null)}
        />
      )}
      <Title
        title={blockCopy.create.roomsBlock.title}
        size="m"
        asComponent="h3"
      />
      <AddAccommodationRoom accommodationBlockId={block.id} />
      <AccommodationRoomTable
        block={block}
        setShowDeleteModal={setShowDeleteModal}
        setShowEditModal={setShowEditModal}
      />
    </Spacer>
  );
};
